import { gql } from 'graphql-request'
import { createQuery } from '@fivehealth/botero'

const GRAPHQL_DOCUMENT = gql`
  query getAllUids(
    $first: Int
    $offset: Int
    $department: [String]
    $designation: [String]
    $sortBy: DirectoryProfileOrderBy
    $profileActivationStatus: ProfileActivationStatus
    $profileActivationStatusIn: [ProfileActivationStatus!]
    $sortDesc: Boolean
    $uids: [String]
    $search: String
  ) {
    hospitalDirectoryProfiles(
      first: $first
      offset: $offset
      uid_In: $uids
      departmentFk_Name_In: $department
      designationFk_Name_In: $designation
      profileActivationStatus: $profileActivationStatus
      profileActivationStatusIn: $profileActivationStatusIn
      sortDesc: $sortDesc
      sortBy: $sortBy
      search: $search
    ) {
      allUids
    }
  }
`

export default createQuery({
  gqlDocument: GRAPHQL_DOCUMENT,
  queryType: 'query',
  baseQueryKey: 'allDirectoryProfileUids',
  paginate: 'offset',
  keepPreviousData: true,
})
